require('../../../../_lib/jquery.passwordRequirementsModified');

jQuery(document).ready(() => {
  $('.pr-password').passwordRequirements();

  $('#showhide').on('click', function () {
    const btn = $(this);
    const hideText = __('hide');
    const showText = __('show');
    if (btn.val() === showText) {
      btn.val(hideText);
      $("input[name='password'], input[name='re-password']").attr('type', 'text');
    } else {
      btn.val(showText);
      $("input[name='password'], input[name='re-password']").attr('type', 'password');
    }
  });
});
